<template>
  <div class="loader-wrapper">
    <ScaleLoader :loading="loading" :color="color"></ScaleLoader>
  </div>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  name: 'loader2',
  components: {
    ScaleLoader,
  },
  data() {
    return {
      color: '#10328f',
      loading: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
}
</style>
